import { render, staticRenderFns } from "./AlarmMonitor.vue?vue&type=template&id=5bf0f086&scoped=true&"
import script from "./AlarmMonitor.vue?vue&type=script&lang=js&"
export * from "./AlarmMonitor.vue?vue&type=script&lang=js&"
import style0 from "./AlarmMonitor.vue?vue&type=style&index=0&id=5bf0f086&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf0f086",
  null
  
)

export default component.exports